package co.maytes.standupbot.dashboard.components.layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.motion.FadeInOnMount
import co.maytes.standupbot.dashboard.features.setup.OAuthOutcomeHandler
import co.maytes.standupbot.dashboard.features.setup.ReconnectBanner
import co.maytes.standupbot.dashboard.features.setup.SetupStatusLoader
import co.maytes.standupbot.dashboard.styles.Layout
import co.maytes.standupbot.dashboard.styles.SettingsClasses
import co.maytes.standupbot.dashboard.styles.Spacing
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.CSSNumeric
import org.jetbrains.compose.web.css.vh

enum class ShellGround { Page, Canvas }

val LocalNavDismiss = compositionLocalOf<() -> Unit> { {} }

@Composable
fun AppShell(
    hideNav: Boolean = false,
    ground: ShellGround = ShellGround.Page,
    contentMaxWidth: CSSNumeric = Layout.wide,
    centered: Boolean = true,
    sidebar: (@Composable () -> Unit)? = null,
    content: @Composable () -> Unit,
) {
    var drawerOpen by remember { mutableStateOf(false) }
    val routeKey = rememberPageContext().route.path

    OAuthOutcomeHandler()
    if (!hideNav) SetupStatusLoader(routeKey)

    if (hideNav) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(100.vh)
                .let { if (ground == ShellGround.Canvas) it.classNames(SettingsClasses.GROUND_CANVAS) else it },
        ) {
            TopBar(onMenuClick = null)
            Column(
                modifier = Modifier.fillMaxWidth().padding(leftRight = Spacing.lg, topBottom = Spacing.xl),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .styleModifier { property("max-width", Layout.wizard.toString()) },
                ) {
                    FadeInOnMount(key = routeKey) { content() }
                }
            }
        }
    } else {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(100.vh)
                .let { if (ground == ShellGround.Canvas) it.classNames(SettingsClasses.GROUND_CANVAS) else it },
        ) {
            SideNav(sidebar)
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .styleModifier {
                        property("flex", "1 1 auto")
                        property("min-width", "0")
                    },
            ) {
                TopBar(onMenuClick = { drawerOpen = true }, mobileOnly = true)
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(leftRight = Spacing.xl, topBottom = Spacing.lg),
                    horizontalAlignment = if (centered) Alignment.CenterHorizontally else Alignment.Start,
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .styleModifier { property("max-width", contentMaxWidth.toString()) },
                    ) {
                        ReconnectBanner()
                        ResumeOnboardingBanner()
                        FadeInOnMount(key = routeKey) { content() }
                    }
                }
            }
        }
    }

    CompositionLocalProvider(LocalNavDismiss provides { drawerOpen = false }) {
        MobileNav(onDismiss = { drawerOpen = false }, open = drawerOpen && !hideNav, content = sidebar)
    }
}
